var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSignOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.36,70.77h9.2V66.13h4.56a4.65,4.65,0,0,0,4.65-4.65V47.81a4.65,4.65,0,0,0-4.65-4.65H45.56V38.68H63.77V29.44H54.64V24.87H45.36v4.57H40.8a4.64,4.64,0,0,0-4.64,4.64V47.55A4.65,4.65,0,0,0,40.8,52.2H54.52v4.64H36.16v9.29h9.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.68,11.21H13.32a9,9,0,0,0-9,9V75.37a9,9,0,0,0,9,9H86.68a9,9,0,0,0,9-9V20.25A9,9,0,0,0,86.68,11.21Zm-.1,63.92H13.39V20.4H86.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignOutlineIcon);
export default __webpack_public_path__ + "static/media/DollarSignOutlineIcon.618bacba6d0de9b5fcf0e311ea7d8131.svg";
export { ForwardRef as ReactComponent };